<!-- TODO: Use events to detect errors instead of angular change detection to increase performances  -->
<div fxLayout="column" [ngClass]="{ 'underline-field': isMaterialDesign }">
  <div *ngIf="label.length > 0" class="input-label">{{ label }}</div>
  <div
    *ngIf="newDesign && type === 'number'"
    style="margin-top: 8px"
    fxLayout="row"
    fxLayoutAlign="center center"
    class="input-container"
    [class.input-error]="getIsError()"
  >
    <mat-icon (click)="decreaseNumber()" class="new-design-icon-background">horizontal_rule</mat-icon>
    <span class="new-design-value">{{ inputValue }}</span>
    <mat-icon (click)="increaseNumber()" class="new-design-icon-background">add</mat-icon>
  </div>

  <div *ngIf="!newDesign" class="input-container" [class.input-error]="getIsError()">
    <div class="icon">
      <mat-icon *ngIf="icon && iconType === 'mat-icon'">
        {{ icon }}
      </mat-icon>

      <img *ngIf="icon && iconType === 'image'" class="svg" [src]="icon" alt="" />
    </div>

    <input
      #input
      *ngIf="formCtrl"
      [type]="type"
      (blur)="onBlur()"
      (keyup)="onKeyUpHandler(input.value)"
      [class.input-with-icon]="icon"
      [class.input-without-icon]="!icon"
      [class.hide-border]="hideBorder"
      [placeholder]="placeholder"
      [formControl]="formCtrl"
      [max]="maxNumber"
      [min]="minNumber"
      [value]="inputValue"
      [attr.name]="attributeName"
      [autocomplete]="autoComplete"
      [attr.data-dashlane-rid]="autoComplete === 'off' ? 'noinput' : null"
      [attr.data-form-type]="autoComplete === 'off' ? 'other' : null"
    />

    <input
      #input
      *ngIf="!formCtrl"
      [type]="type"
      (blur)="onBlur()"
      (keyup)="onKeyUpHandler(input.value)"
      [(ngModel)]="inputModel"
      (ngModelChange)="inputModelChangeHandler()"
      [class.input-with-icon]="icon"
      [class.input-without-icon]="!icon"
      [class.hide-border]="hideBorder"
      [placeholder]="placeholder"
      [disabled]="disabled"
      [max]="maxNumber"
      [min]="minNumber"
      [value]="inputValue"
    />

    <div
      class="number-buttons"
      [class.custom-icons]="numberButtonsIconUp != 'arrow_drop_up'"
      *ngIf="type === 'number' && showNumberButtons"
      fxLayout="column"
      fxLayoutAlign="start start"
    >
      <div
        class="increase-button"
        fxLayout="column"
        fxLayoutAlign="center center"
        (click)="increaseNumber()"
        [attr.disabled]="disabled ? true : null"
        [class.disabled-button]="disabled || (formCtrl && formCtrl.disabled)"
      >
        <mat-icon>{{ numberButtonsIconUp }}</mat-icon>
      </div>
      <div
        class="decrease-button"
        fxLayout="column"
        fxLayoutAlign="center center"
        (click)="decreaseNumber()"
        [attr.disabled]="disabled ? true : null"
        [class.disabled-button]="disabled || (formCtrl && formCtrl.disabled)"
      >
        <mat-icon> {{ numberButtonsIconDown }}</mat-icon>
      </div>
    </div>
    @if (isItPassword) {
      <mat-icon class="password-icon" fontSet="material-symbols-outlined" (click)="togglePassword()"
        >{{ type === 'text' ? 'visibility_off' : 'visibility' }}
      </mat-icon>
    }
  </div>
  <div class="input-hint-message" *ngIf="!getIsError() && hintMessage.length > 0">{{ hintMessage }}</div>
  <div class="input-error-message" *ngIf="getIsError()">{{ getErrorMessageToShow() }}</div>
</div>
